import { useDataGridContext as t } from "./index.es764.js";
function o() {
  return t().dataGridState;
}
export {
  o as useDataGridState
};
//# sourceMappingURL=index.es762.js.map
